// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function () {
	"use strict";

	angular.module("swurveys.common", ["ngStorage"])
    .run(run);

    function run($window, analyticsService) {
        /*$window.onerror = function customErrorHandler (errorMessage, url, lineNumber, columnNumber, error) {
        	//Errors may happen before GA is initialized.
            if (typeof ga === 'function') {

                var exDescription = errorMessage;
                if (typeof error!== 'undefined' && typeof error.message !== 'undefined') {
                    exDescription = error.message;
                }

                exDescription += ' @ ' + url + ':' + lineNumber + ':' + columnNumber;

                analyticsService.trackException(exDescription);
            }

            return false;
        };*/
    }
}());
